import { atom, createStore } from 'jotai';
import { User, UpdateCrewDto } from '../../../shared/types';

// Create a Jotai store instance
export const store = createStore();

// User-related atoms
export const userAtom = atom<User | null>(null);

// Transient crew theme override - set while editing Appearance settings so
// CrewWrapper can preview unsaved colors across the full page in real time.
// Cleared when the settings component unmounts.
export const crewThemeOverrideAtom = atom<{
    slug: string;
    themeConfig: NonNullable<UpdateCrewDto['themeConfig']>;
} | null>(null);
